import httpClient from "./httpClient";

const putApiData = async (url, body) => {
  const response = await httpClient.put(url, body);
  return response;
};

export default putApiData;
